import { React, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';


export default function WeekAttendanceStatusView(props) {
  const { dayOfTheWeek, attendanceData } = props;

  const [count, setCount] = useState(5);

  useEffect(() => {
    console.log(attendanceData);
  }, [attendanceData])

  // 카운트다운 //
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        if (prev <= 1) { clearInterval(interval); return 1; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [])

  // 글자 수 세기 //
  function decideStoreNameText() {
    let name = attendanceData.storeName;

    if (name.length <= 9) return name;
    else return name.slice(0, 9) + '...';
  }

  // 요일별 화이팅 문구 변경 //
  function decideFighttingText() {
    if (dayOfTheWeek === 'Mon') return '시작이 좋아 월요팅!!';
    else if (dayOfTheWeek === 'Tue') return '화요일도 출석 응원해!';
    else if (dayOfTheWeek === 'Wed') return '벌써 수요일 오늘도 화이팅!';
    else if (dayOfTheWeek === 'Thu') return '목요일, 이제 거의 다 왔어!';
    else if (dayOfTheWeek === 'Fri') return '금요일, 이번 한주도 수고했어!!!';
    else if (dayOfTheWeek === 'Sat') return '토요일까지 운동!';
    else if (dayOfTheWeek === 'Sun') return '일요일도 운동은 해야지!!';
  }

  return (
    <TopLevelWrapper>
      <ExplanationWrapper>
        <ExplanationText color='#595959'>{decideStoreNameText()}</ExplanationText>
        {/* <ExplanationText color='#595959'>링코 짐 피트니스</ExplanationText> */}
      </ExplanationWrapper>
      <ExplanationWrapper style={{ marginTop: '4px' }}>
        <EmphasizeExplanationText color='#595959'>{attendanceData.totalAttendance.toLocaleString('ko-KR')}번 출석중</EmphasizeExplanationText>
      </ExplanationWrapper>
      <ExplanationWrapper style={{ marginTop: '4px' }} /*style={{ marginTop: `26px` }}*/>
        <FighttingText color='#FF8B48'>{decideFighttingText()}</FighttingText>
      </ExplanationWrapper>
      <ClassTotalView>
        <KeypadLayerWrapper>
          <NumberKey isAttendance={attendanceData.mon}>
            <NumText>월</NumText>
          </NumberKey>
          <NumberKey isAttendance={attendanceData.tue}>
            <NumText>화</NumText>
          </NumberKey>
          <NumberKey isAttendance={attendanceData.wed}>
            <NumText>수</NumText>
          </NumberKey>
        </KeypadLayerWrapper>
        <KeypadLayerWrapper>
          <NumberKey isAttendance={attendanceData.thu}>
            <NumText>목</NumText>
          </NumberKey>
          <NumberKey isAttendance={attendanceData.fri}>
            <NumText>금</NumText>
          </NumberKey>
          <NumberKey isAttendance={attendanceData.sat}>
            <NumText>토</NumText>
          </NumberKey>
        </KeypadLayerWrapper>
        <KeypadLayerWrapper>
          <NumberKey isAttendance={attendanceData.sun}>
            <NumText>일</NumText>
          </NumberKey>
        </KeypadLayerWrapper>
      </ClassTotalView>
      <FiveSecondsTextWrapper>
        <FiveSecondsText>{count}초뒤 메인화면으로 이동합니다</FiveSecondsText>
      </FiveSecondsTextWrapper>
      {
        (attendanceData.attendancePoint > 0 || attendanceData.consecutiveAttendancePoint > 0) &&
        <TotalAttendancePointBoxWrapper>
          {
            attendanceData.attendancePoint > 0 &&
            <AttendancePointBox>
              <AttendenceText>출석 포인트</AttendenceText>
              <AttendanceTextWrapper>
                <PointText>+</PointText>
                <PointNumberText>{attendanceData.attendancePoint.toLocaleString('ko-KR')}</PointNumberText>
                <PointText>point</PointText>
              </AttendanceTextWrapper>
            </AttendancePointBox>
          }
          {
            attendanceData.consecutiveAttendancePoint > 0 &&
            <ConsecutiveAttendancePointBox>
              <ConsecutiveAttendenceText>연속 출석 포인트</ConsecutiveAttendenceText>
              <AttendanceTextWrapper>
                <PointText>+</PointText>
                <PointNumberText>{attendanceData.consecutiveAttendancePoint.toLocaleString('ko-KR')}</PointNumberText>
                <PointText>point</PointText>
              </AttendanceTextWrapper>
            </ConsecutiveAttendancePointBox>
          }
        </TotalAttendancePointBoxWrapper>
      }
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;

  padding-top: 10%;

  // overflow-y: auto;

  animation-name: ${startAnimation};
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const ExplanationText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 18px;
  }
  @media (min-height: 640px) {
    font-size: 20px;
  }
  @media (min-height: 720px) {
    font-size: 22px;
  }
  @media (min-height: 760px) {
    font-size: 24px;
  }
  @media (min-height: 800px) {
    font-size: 26px;
  }
  @media (min-height: 1000px) {
    font-size: 28px;
  }
  @media (min-height: 1200px) {
    font-size: 30px;
  }

  &:hover {
    cursor: default;
  }
`;

const EmphasizeExplanationText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 18px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 18px;
  }
  @media (min-height: 640px) {
    font-size: 20px;
  }
  @media (min-height: 720px) {
    font-size: 22px;
  }
  @media (min-height: 760px) {
    font-size: 24px;
  }
  @media (min-height: 800px) {
    font-size: 26px;
  }
  @media (min-height: 1000px) {
    font-size: 28px;
  }
  @media (min-height: 1200px) {
    font-size: 30px;
  }

  &:hover {
    cursor: default;
  }
`;

const FighttingText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 16px;
  }
  @media (min-height: 640px) {
    font-size: 18px;
  }
  @media (min-height: 720px) {
    font-size: 20px;
  }
  @media (min-height: 760px) {
    font-size: 22px;
  }
  @media (min-height: 800px) {
    font-size: 24px;
  }
  @media (min-height: 1000px) {
    font-size: 26px;
  }
  @media (min-height: 1200px) {
    font-size: 28px;
  }

  &:hover {
    cursor: default;
  }
`;

const ClassTotalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 24px;

  // width: 84.89%;
  width: 64.75%;

  // gap: 43px;
  gap: 24px;


  transition: all 0.3s ease-in-out;
`;

const KeypadLayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // margin-top: 34px;
  width: 100%;
`;

const NumberKey = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-bottom: 29%;

  width: 29%;

  border-radius: 12px;
  background-color: ${props => props.isAttendance ? `#FF8B48` : `#DDDDDD`};

  transition: all 0.3s ease-in-out;
`;

const NumText = styled.p`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  border-radius: 12px;

  font-family: NotoSansKR-Bold;
  font-size: 17px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 17px;
  }
  @media (min-height: 640px) {
    font-size: 19px;
  }
  @media (min-height: 720px) {
    font-size: 21px;
  }
  @media (min-height: 760px) {
    font-size: 22px;
  }
  @media (min-height: 800px) {
    font-size: 23px;
  }
  @media (min-height: 1000px) {
    font-size: 30px;
  }
  @media (min-height: 1200px) {
    font-size: 40px;
  }

  &:hover {
    cursor: default;
  }
`;

const FiveSecondsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // margin-top: 86px;
  margin-top: 24px;
`;

const FiveSecondsText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #FF8B48;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 14px;
  }
  @media (min-height: 680px) {
    font-size: 16px;
  }
  @media (min-height: 720px) {
    font-size: 18px;
  }
  @media (min-height: 760px) {
    font-size: 20px;
  }
  @media (min-height: 800px) {
    font-size: 22px;
  }
  @media (min-height: 1000px) {
    font-size: 24px;
  }
  @media (min-height: 1200px) {
    font-size: 26px;
  }
`;


const TotalAttendancePointBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 64.75%;

  gap: 10px;
`;

const AttendancePointBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 4px 6px;

  width: calc(100% - 60px);

  border-radius: 10px;
  background-color: #FF8B48;

  @media (min-height: 320px) {
    padding: 4px 6px;

    width: calc(100% - 12px);

    border-radius: 6px;
  }
  @media (min-height: 640px) {
    padding: 6px 8px;

    width: calc(100% - 16px);

    border-radius: 8px;
  }
  // @media (min-height: 720px) {
  //   padding: 8px 10px;

  //   width: calc(100% - 20px);
  // }
  // @media (min-height: 760px) {
  //   padding: 10px 12px;

  //   width: calc(100% - 24px);
  // }
  @media (min-height: 800px) {
    padding: 12px 14px;

    width: calc(100% - 28px);

    border-radius: 10px;
  }
  @media (min-height: 1000px) {
    padding: 14px 16px;

    width: calc(100% - 32px);

    border-radius: 10px;
  }
  @media (min-height: 1200px) {
    padding: 16px 18px;

    width: calc(100% - 36px);

    border-radius: 10px;
  }
`;

const ConsecutiveAttendancePointBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 28px 30px;

  width: calc(100% - 60px);

  border-radius: 10px;
  background-color: #6DD49E;

  @media (min-height: 320px) {
    padding: 4px 6px;

    width: calc(100% - 12px);

    border-radius: 6px;
  }
  @media (min-height: 640px) {
    padding: 6px 8px;

    width: calc(100% - 16px);

    border-radius: 8px;
  }
  // @media (min-height: 720px) {
  //   padding: 8px 10px;

  //   width: calc(100% - 20px);
  // }
  // @media (min-height: 760px) {
  //   padding: 10px 12px;

  //   width: calc(100% - 24px);
  // }
  @media (min-height: 800px) {
    padding: 12px 14px;

    width: calc(100% - 28px);

    border-radius: 10px;
  }
  @media (min-height: 1000px) {
    padding: 14px 16px;

    width: calc(100% - 32px);

    border-radius: 10px;
  }
  @media (min-height: 1200px) {
    padding: 16px 18px;

    width: calc(100% - 36px);
    
    border-radius: 10px;
  }
`;

const AttendanceTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const ConsecutiveAttendenceText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 10px;
  }
  @media (min-height: 640px) {
    font-size: 12px;
  }
  // @media (min-height: 720px) {
  //   font-size: 14px;
  // }
  // @media (min-height: 760px) {
  //   font-size: 16px;
  // }
  @media (min-height: 800px) {
    // font-size: 18px;
    font-size: 14px;
  }
  @media (min-height: 1000px) {
    // font-size: 20px;
    font-size: 16px;
  }
  @media (min-height: 1200px) {
    // font-size: 22px;
    font-size: 18px;
  }

  &:hover {
    cursor: default;
  }
`;

const AttendenceText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 12px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 14px;
  }
  // @media (min-height: 720px) {
  //   font-size: 16px;
  // }
  // @media (min-height: 760px) {
  //   font-size: 18px;
  // }
  @media (min-height: 800px) {
    // font-size: 20px;
    font-size: 16px;
  }
  @media (min-height: 1000px) {
    // font-size: 22px;
    font-size: 18px;
  }
  @media (min-height: 1200px) {
    // font-size: 24px;
    font-size: 20px;
  }

  &:hover {
    cursor: default;
  }
`;

const PointNumberText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 12px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 14px;
  }
  // @media (min-height: 720px) {
  //   font-size: 16px;
  // }
  // @media (min-height: 760px) {
  //   font-size: 18px;
  // }
  @media (min-height: 800px) {
    // font-size: 20px;
    font-size: 16px;
  }
  @media (min-height: 1000px) {
    // font-size: 22px;
    font-size: 18px;
  }
  @media (min-height: 1200px) {
    // font-size: 24px;
    font-size: 20px;
  }

  &:hover {
    cursor: default;
  }
`;

const PointText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 10px;
  }
  @media (min-height: 640px) {
    font-size: 12px;
  }
  // @media (min-height: 720px) {
  //   font-size: 14px;
  // }
  // @media (min-height: 760px) {
  //   font-size: 16px;
  // }
  @media (min-height: 800px) {
    // font-size: 18px;
    font-size: 14px;
  }
  @media (min-height: 1000px) {
    // font-size: 20px;
    font-size: 16px;
  }
  @media (min-height: 1200px) {
    // font-size: 22px;
    font-size: 18px;
  }

  &:hover {
    cursor: default;
  }
`;